// extracted by mini-css-extract-plugin
export default {"wrap":"MH-z","subtitle":"NH-z","contentWrap":"OH-z","imgWrap":"PH-z","heading":"QH-z","copy":"RH-z"};